import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFaceIdLockBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd" opacity={0.4}>
      <path d="M8.15 20.251H6.893a3.145 3.145 0 0 1-3.143-3.14v-1.569a.75.75 0 0 0-1.5 0v1.569a4.647 4.647 0 0 0 4.643 4.64H8.15a.75.75 0 0 0 0-1.5M21.002 14.792a.75.75 0 0 0-.75.75v1.569c0 1.732-1.41 3.14-3.143 3.14h-1.29a.75.75 0 0 0 0 1.5h1.29a4.647 4.647 0 0 0 4.643-4.64v-1.569a.75.75 0 0 0-.75-.75M3 9.221a.75.75 0 0 0 .75-.75v-1.57A3.15 3.15 0 0 1 6.893 3.75h1.289a.75.75 0 0 0 0-1.5H6.893A4.65 4.65 0 0 0 2.25 6.901v1.57c0 .414.336.75.75.75M17.109 2.251h-1.257a.75.75 0 0 0 0 1.5h1.257a3.15 3.15 0 0 1 3.143 3.15v1.571a.75.75 0 0 0 1.5 0V6.901a4.65 4.65 0 0 0-4.643-4.65" />
    </g>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.98 8.24h.012c.775 0 1.41.626 1.42 1.391v.51H10.59v-.508a1.414 1.414 0 0 1 1.39-1.393m4.378 6.48v-2.04a2.54 2.54 0 0 0-1.445-2.28v-.779a2.927 2.927 0 0 0-2.928-2.88h-.025a2.91 2.91 0 0 0-2.871 2.88v.78a2.54 2.54 0 0 0-1.446 2.28v2.04a2.547 2.547 0 0 0 2.547 2.54h3.622a2.546 2.546 0 0 0 2.546-2.54"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFaceIdLockBulk);
export default ForwardRef;
